// VicTech #710:大脑(CSKayuBrain)转真人时加的标签;改名要两边一起改。
export const NEED_HUMAN_LABEL = 'need-human';
export const NEED_HUMAN_TAB_KEY = 'victech_need_human';
